<template>
  <div class="modal-overlay" v-if="translations && storeModalMessage !== 'close'">
    <div class="modal-content share" v-if="storeModalMessage === 'share'">

      <div class="close-btn" @click="closeModalWindow()" aria-label="Fermer la fenêtre">&times;</div>

      <div id="zone">

            <div id="intro">
              <div class="content">
              <div v-html="translations.modalPartage[langue][0]" style="margin-bottom: 20px;">
              </div>
                  <button class="focus-btn"
                    @click="copyUrlToClipboard();">
                    <img src="interface/copy.png" alt="Copier" style="vertical-align:middle;margin-right">
                    <span v-if="!showCopyBubble">{{ translations.modalPartage[langue][1] }}</span>
                    <span v-else>{{ translations.modalPartage[langue][2] }}</span>
                  </button>
                </div>
            </div>
           
            <div id="formulaire" :urlToShare="$store.getters.urlToShare">
              <mail 
                :mailLabel="translations.mail[langue][0]"
                :subjectLabel="translations.mail[langue][1]"
                :messageLabel="translations.mail[langue][2]"
                :messageSendLabel="translations.mail[langue][3]"
                :messageErreurLabel="translations.mail[langue][4]"
                :sendLabel="translations.mail[langue][5]"
                :sendingLabel="translations.mail[langue][6]"
                :labelButton="translations.mail[langue][7]"
                :urlToShare="$store.getters.urlToShare"
              /> 
            </div>
        </div>

    </div>
    <div class="modal-content stats" v-if="storeModalMessage === 'datas' && modeAdmin === true">
      <statsDatas />
    </div>
     <div class="modal-content stats" v-if="storeModalMessage === 'stats' && modeAdmin === true">
      <statsRefs />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import mail from './mail.vue'; // Assurez-vous que le chemin est correct
import statsDatas from './statsDatas.vue';  
import statsRefs from './statsRefs.vue';  


export default {
  name: 'ModalMessage',
  components: {
    mail,
    statsDatas,
    statsRefs
  },
  props: {
    langue: String,
    translations: Object, // Assurez-vous que les traductions sont passées en tant que prop
    
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      showCopyBubble: false, // Pour afficher la bulle de confirmation
    };
  },
  computed: {
    ...mapState(['storeModalMessage', 'storeUrlArray', 'modeAdmin']),
  },
  methods: {
    ...mapActions(['updateStateValue']),

    closeModalWindow() { // Anciennement closeModal
      this.updateStateValue({ key: 'storeModalMessage', value: 'close' });
    },

    openLink(url) { // Nouvelle fonction
      if (url) {
        window.open(url, '_blank'); // Ouvre l'URL dans un nouvel onglet
      } else {
        console.error('URL invalide ou manquante');
      }
    },

    copyUrlToClipboard() {
      const url = this.$store.getters.urlToShare;
      if (!url) return;

      // Vérifie la disponibilité de l'API clipboard
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(url)
          .then(() => {
            this.showCopyBubble = true;
            setTimeout(() => {
              this.showCopyBubble = false;
            }, 2000);
          })
          .catch(() => {
            this.fallbackCopyText(url);
          });
      } else {
        this.fallbackCopyText(url);
      }
    },
    fallbackCopyText(text) {
      // Fallback universel
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.showCopyBubble = true;
        setTimeout(() => {
          this.showCopyBubble = false;
        }, 2000);
      } catch (err) {
        alert('Impossible de copier le lien automatiquement.');
      }
      document.body.removeChild(textarea);
    },
  },
  watch: {
    storeModalMessage(newVal) {
      if (newVal) {
        // Sauvegarde l'action dans la base à chaque changement de modal
        if (newVal !== 'close') {
          this.$store.dispatch('saveActionToMemo', {
            action: 'modal',
            tag: 'model',
            value: newVal
          });
        }
      }
      if (newVal === 'quicklink') {
        this.updateStateValue({ key: 'storeModalMessage', value: 'quicklink' });
      }
    }
  },
  mounted() {
   
  },
  beforeUnmount() {
   
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(var(--colorVeryDark-rgb), 1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.share{
  width: 400px;
}
.stats{
  height: 80vh;
  max-height: 80vh;
}

.modal-content {
  max-width: 90vw;
  position: relative;
  border: white 4px solid;
  border-radius: 14px;
  display: flex;
}

.close-btn {
  position: absolute;
  top: 7px;
  right: 20px;
  background: transparent;
  border: none;
  color: var(--colorDark, black);
  font-size: 2rem;
  font-weight: bold;
  cursor: pointer;
  z-index: 10;
  transition: color 0.2s;
}

.close-btn:hover {
  color: var(--colorActive, #f33);
}

#intro {
  width: 100%;
  text-align: center;
  background-color: white;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column wrap;
} 
.content {
  margin: 20px;
}

#formulaire {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
  height: 100%;
  padding: 20px;
}

button {
  padding: 10px 20px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  margin: 0 4px;
}

button.focus-btn {
  background-color: var(--colorLight);
  color: var(--colorDark);
}
button.focus-btn img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 8px;
}
button.focus-btn:hover {
  background-color: var(--colorActive);
  color: var(--colorDark);
}
</style>